import React, { useContext, useState, useEffect } from 'react'
import axios from "axios";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { IconPlus } from '@tabler/icons-react';
import Fab from '@mui/material/Fab';
import Autocomplete from '@mui/material/Autocomplete';
import { GlobalContext } from '../contexts/GlobalContext'
import 'filepond/dist/filepond.css'
import { useNavigate } from 'react-router-dom';
import { format, parse } from 'date-fns';
import heic2any from 'heic2any';
import { Alert, Snackbar } from '@mui/material';
import { getBlobFromUri } from '../utils/cordovaFileUtils';

registerPlugin(FilePondPluginFileRename);
registerPlugin(FilePondPluginFileValidateType);

function TicketsGlobal(props) {
    const { url, phone, setPhone, contact, setContact, customer, setCustomer, customerName, setCustomerName, token, setToken, ledgers, portal } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [ledger, setLedger] = useState("")
    const [subject, setSubject] = useState("")
    const [content, setContent] = useState("")
    const [files, setFiles] = useState([])
    const [pond, setPond] = useState('')
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [fileValidation, setFileValidation] = useState(true)

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSubject("");
        setContent("");
        setFiles([]);
        setLoading(false);
        setFileList([]);
    };

    const handleCamera = () => {
        setFileValidation(false);
        navigator.camera.getPicture((fileUri) => {
            getBlobFromUri(fileUri)
                .then((fileObject) => pond.addFile(fileObject))
                .then((file) => {
                    setFiles(prevFiles => [...prevFiles, file]);
                    setFileValidation(true);
                })
                .catch((error) => {
                    console.error("File processing failed:", error);
                    setFileValidation(true);
                });
        }, (message) => {
            console.error("Camera failed:", message);
            setFileValidation(true);
        }, {
            quality: 50,
            destinationType: Camera.DestinationType.FILE_URI,
            encodingType: Camera.EncodingType.JPEG,
            mediaType: Camera.MediaType.PICTURE,
            correctOrientation: true,
            sourceType: Camera.PictureSourceType.CAMERA,
            saveToPhotoAlbum: false
        });
    };

    const handleFile = () => {
        pond.browse();
    };

    const handleScanner = () => {
        window.scan.scanDoc(function (imageData) {
            pond.addFile("data:image/jpg;base64," + imageData)
        }, function (message) {
            alert(message);
        }, { sourceType: 1, quality: 0.5, returnBase64: true })
    };

    const fileRenameFunction = (file) => {
        console.log("file", file);
        if (file.extension == file.name) {
            return `f_${Math.random().toString(36).slice(2, 7)}_${(+new Date).toString(36).slice(-5)}.jpg`;
        } else {
            return `f_${Math.random().toString(36).slice(2, 7)}_${(+new Date).toString(36).slice(-5)}${file.extension}`;
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        // var fileList = [];
        // files.forEach(function(f) {
        //     fileList.push({ file: f.filename, type: f.fileType, ext: f.fileExtension } );
        // })
        const fileNames = files.map(file => file.filename);
        axios.post(url + 'api/ticket/add', {
            customer: customer,
            contact: contact,
            phone: phone,
            creator: portal == "supplier" ? 2 : 3,
            buyer: props.buyer,
            seller: props.seller,
            area: props.area,
            id: props.id,
            subject: subject,
            content: content,
            files: JSON.stringify(fileList.filter(f => fileNames.includes(f.file))),
        }, { headers: { Authorization: `Bearer ${token}` } })
            .then(function (response) {
                if (response.data.error == 0) {
                    setOpen(false);
                    setLoading(false);
                    handleClose();
                    // navigate(0);
                    document.location.reload();
                } else {
                    alert(response.data.message);
                    handleClose()
                }
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
                handleClose()
            });
    };

    function CustomButton() {
        if (props.buttonType == "fab") {
            return (
                <Fab color="primary" aria-label="add" size={"medium"} onClick={handleOpen} sx={{
                    position: "fixed",
                    bottom: (theme) => theme.spacing(2),
                    right: (theme) => theme.spacing(2)
                }}>
                    <IconPlus />
                </Fab>
            )
        } else if (props.buttonType == "card") {
            return (
                <Card sx={{ cursor: 'pointer', width: '100%', maxWidth: '100%', textAlign: 'center', px: 4, py: 4 }} onClick={handleOpen}>
                    {props.icon}
                    <Typography variant="body1" component="p">New {props.title}</Typography>
                </Card>
            )
        } else {
            return (
                <Button variant="contained" size="large" onClick={handleOpen} >+</Button>
            )
        }
    }

    const [data, setData] = useState([]);

    function fetchData() {
        axios.post(url + 'api/tickets/global', {
            customer: customer,
            contact: contact,
            phone: phone,
            id: props.id,
            area: props.area,
        }, { headers: { Authorization: `Bearer ${token}` } })
            .then(function (response) {
                setData(response.data);
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        fetchData();
    }, []);

    const [errorMessage, setErrorMessage] = useState("");
    const [openErrorAlert, setOpenErrorAlert] = useState(false);

    const ErrorMessage = () => {

        function handleClose() {
            setOpenErrorAlert(false)
            setErrorMessage('')
        }

        return (
            <>
                <Snackbar open={openErrorAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                    onClose={handleClose}>
                    <Alert
                        onClose={handleClose}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </>
        )
    }

    function convertHEICToJPG(file) {
        return heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.6
        });
    }

    function getExtension(fileName) {
        if (fileName.includes('.')) {
            // Split the fileName by dot and return the last part
            return '.' + fileName.split('.').pop();
        } else {
            // If there's no dot, return an empty string indicating no extension
            return '';
        }
    }

    const Ticket = (prop) => {
        return (
            <Card onClick={event => { return navigate("/ticket/" + prop.data.id) }} sx={{ border: 1, borderColor: 'divider', cursor: 'pointer', width: '100%', maxWidth: '100%', textAlign: 'center', mt: 4 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, py: 1 }}>
                    <Typography variant="h6" component="h6">{portal == "supplier" ? prop.data.buyer_name : prop.data.seller_name}</Typography>
                </Box>
                <Grid container>
                    <Grid item xs={6} sx={{ borderRight: 1, borderBottom: 1, borderColor: 'divider', px: 1, py: 1 }}>
                        <Typography variant="overline" component="p">Ticket #</Typography>
                        <Typography variant="body" component="p">{prop.data.ticket_no ? prop.data.ticket_no : '-'}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ borderBottom: 1, borderColor: 'divider', px: 1, py: 1 }}>
                        <Typography variant="overline" component="p">Date</Typography>
                        <Typography variant="body" component="p">{prop.data.date ? format(parse(prop.data.date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ px: 1, py: 1 }}>
                        <Typography variant="overline" component="p">Subject</Typography>
                        <Typography variant="body" component="p">{prop.data.subject ? prop.data.subject : ''}</Typography>
                    </Grid>
                </Grid>
            </Card>
        )
    }



    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 4 }}>
                <Typography variant="h6" component="div" sx={{ mb: 0 }}>Tickets</Typography>
                <CustomButton />
            </Box>

            {data.map((row, index) => (
                <Ticket key={row.id} data={row}></Ticket>
            ))}

            {
                Object.keys(data).length == 0 ?
                    <Typography variant="caption" component="div" sx={{ mb: 4 }}>No ticket has been added yet</Typography>
                    :
                    null

            }

            <Dialog onClose={handleClose} open={open}>
                <DialogTitle>New Ticket</DialogTitle>
                <DialogContent sx={{ width: '80vw', maxWidth: '300px' }}>
                    <form onSubmit={handleSubmit}>
                        <InputLabel shrink>Subject</InputLabel>
                        <TextField sx={{ mb: 2 }} fullWidth required={true}
                            value={subject}
                            onChange={event => {
                                const { value } = event.target;
                                setSubject(value);
                            }} />

                        <InputLabel shrink>Message</InputLabel>
                        <TextField sx={{ mb: 2 }} fullWidth required={true}
                            value={content}
                            multiline
                            rows={4}
                            onChange={event => {
                                const { value } = event.target;
                                setContent(value);
                            }} />

                        <InputLabel shrink>Attachments</InputLabel>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ fontSize: "12px" }}> Allowed File types are jpg, jpeg, heic, png, pdf, xls, xlsx, xlsm, xlsb, ods, csv </Typography>
                        </Alert>
                        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", flexDirection: 'row', gap: 1, mb: 2 }}>
                            {window.cordova &&
                                <Button variant="contained" size="medium" onClick={handleCamera}>Camera</Button>
                            }
                            <Button variant="contained" size="medium" onClick={handleFile}>File</Button>
                            {/* { window.cordova &&
                                <Button variant="contained" size="medium" onClick={handleScanner}>Scan</Button>
                            } */}
                        </Box>
                        <FilePond
                            acceptedFileTypes={
                                ["application/pdf",
                                    "image/png",
                                    "image/jpg",
                                    "image/jpeg",
                                    "image/heic",
                                    'application/vnd.ms-excel',  // .xls
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                    'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm
                                    'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // .xlsb
                                    "text/csv", //.csv
                                    "application/vnd.oasis.opendocument.spreadsheet", //.ods
                                    ""
                                ]
                            }
                            ref={ref => (setPond(ref))}
                            credits={false}
                            files={files}
                            onupdatefiles={setFiles}
                            fileRenameFunction={file => (fileRenameFunction(file))}
                            allowMultiple={true}
                            // server={ url + "api/pond/process"}
                            server={{
                                url: url,
                                revert: "./api/pond/process",
                                process: async (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                    const allowedFiles = [".jpg", ".jpeg", ".heic", ".png", ".pdf", ".xls", ".xlsx", ".xlsm", ".xlsb", ".ods", ".csv"]
                                    if (fileValidation) {
                                        if (!allowedFiles.includes(getExtension(file?.name.toLowerCase()))) {
                                            error('Unkown file extension')
                                            setOpenErrorAlert(true)
                                            setErrorMessage('Unsupported file type. Please upload files with the allowed extensions. Allowed File types are jpg, jpeg, heic, png, pdf, xls, xlsx, xlsm, xlsb, ods, csv')
                                            abort()
                                        }
                                    } else {
                                        file.name = file.name + '.jpg';
                                    }
                                    try {
                                        let fn = file.name.toLowerCase()
                                        // Check if the file type is HEIC
                                        if (fn.indexOf('.heic') !== -1) {
                                            // Convert HEIC to JPG
                                            const convertedBlob = await convertHEICToJPG(file);
                                            // Create a new file object from the Blob
                                            const newFile = new File([convertedBlob], file.name.replace(/\.heic$/i, '.jpg'), {
                                                type: "image/jpeg",
                                            });
                                            file = newFile; // Update the file reference
                                        }

                                        // Now upload the file (either original or converted)
                                        // Example using fetch API
                                        const formData = new FormData();
                                        formData.append(fieldName, file, file.name);
                                        const response = await fetch(url + "api/pond/process", {
                                            method: 'POST',
                                            body: formData
                                        });

                                        if (response.ok) {
                                            const data = await response.json();
                                            load(data.name);
                                            let currentFile = { file: data.name, type: data.type, ext: data.ext };
                                            setFileList(currentFiles => [...currentFiles, currentFile]);
                                        } else {
                                            error('Could not upload file');
                                        }
                                    } catch (err) {
                                        error(err.message);
                                    }
                                }
                            }}
                            name="files" /* sets the file input name, it's filepond by default */
                            labelIdle='No files selected'
                            onaddfile={(error, file) => {
                                if (!error) {
                                    setLoading(true)
                                }
                            }}
                            onprocessfiles={() => setLoading(false)}
                            //  onprocessfilerevert={() => {setLoading(true)}}   
                            // onremovefile={() => {
                            //     setLoading(false); 
                            //     setOpenErrorAlert(false); 
                            //     setErrorMessage("")
                            // }} 

                            onerror={(error, file) => {
                                console.log({ error, file })
                                // const filesArray = files?.filter((item) => (item?.id !== file?.id));
                                // setFiles(filesArray)
                            }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                            <LoadingButton type="submit" loading={loading} variant="contained">Save</LoadingButton>
                        </Box>
                    </form>
                    {openErrorAlert &&
                        <>
                            <ErrorMessage />
                        </>
                    }
                </DialogContent>
            </Dialog>
        </div>
    )
}
export default TicketsGlobal;